import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { securityRoute } from './../constants/app-url-constants';
import { MenuService } from './shared/services/menu.service';

@Injectable({
  providedIn: 'root',
})
export class UrlSecurityGuard implements CanActivate {
  constructor(private service: MenuService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentParentURL = _.compact(state.url.split('?')[0].split('/'));
    if (currentParentURL && currentParentURL.length) {
      if (
        securityRoute &&
        securityRoute.length &&
        securityRoute.indexOf('/' + currentParentURL[0]) >= 0
      ) {
        return true;
      } else {
        return this.service.getMenuForSecurityList().then((data: any) => {
          if (data) {
            const urlParent = currentParentURL[0];

            // To support 2 levels of parent check, check only first two level
            // eg: proposals/events <-- this is considered as one parent as per api
            const urlParent2 =
              currentParentURL.length > 1
                ? `${currentParentURL[0]}/${currentParentURL[1]}`
                : currentParentURL[0];

            if (data.indexOf(urlParent) >= 0 || data.indexOf(urlParent2) >= 0) {
              return true;
            } else {
              this.router.navigate([data[0]]);
              return false;
            }
          }
        });
      }
    }
  }
}
